import { EMPTY_STRING_ID } from '@/constant/common'
import commonRepo from '@/repository/common.repo'

import { DTO } from '../DTO'
import { SchoolGrade } from '../Student/SchoolGrade'

export class PaymentStudent extends DTO implements res.StudentPayment {
  studentId = EMPTY_STRING_ID
  academyId = EMPTY_STRING_ID
  studentName: res.Student['name']
  studentSchoolType: res.Student['schoolType']
  studentGrade: res.Student['grade']
  schoolGrade = new SchoolGrade()
  index: number
  studentStatus: res.Student['status']
  activeDateCount: number
  solveCount: number

  get studentStatusInKor() {
    if (this.studentStatus === 'INACTIVE') return commonRepo.isSchoolflat ? '비활성' : '퇴원'
    if (this.studentStatus === 'ACTIVE') return commonRepo.isSchoolflat ? '활성' : '재원'
    return '삭제'
  }

  constructor(data) {
    super()

    this.studentId = data.studentId
    this.academyId = data.academyId
    this.studentName = data.studentName
    this.studentSchoolType = data.studentSchoolType
    this.studentGrade = data.studentGrade
    this.schoolGrade = new SchoolGrade({
      schoolType: this.studentSchoolType,
      grade: this.studentGrade,
    })
    this.index = data.index
    this.studentStatus = data.studentStatus
    this.activeDateCount = data.activeDateCount
    this.solveCount = data.solveCount
  }
}
